import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues, getAppliedFilter } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuRadioSelect } from './SbSharedRefineMenuRadioSelect';
import { SbSharedRefineMenuTypeaheadContainer } from '../SbSharedRefineMenuTypeahead/SbSharedRefineMenuTypeaheadContainer';

/* eslint-disable react/prop-types, react/display-name */

export const SbSharedRefineMenuRadioSelectSearchComponent = props => {
    const { viewer, values, searchBrowse, filterName, totalCount } = props;
    const { appliedFilters, displayUriRef } = searchBrowse;

    const appliedFilter = getAppliedFilter(appliedFilters, filterName);
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const canBeDismissed = appliedFilter ? appliedFilter.canBeDismissed : true;

    return (
        <SbSharedRefineMenuTypeaheadContainer
            viewer={viewer}
            filterName={filterName}
            searchBrowse={searchBrowse}
            availableFilterValues={values}
            appliedFilterValues={appliedFilterValues}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuRadioSelect
                    filterName={filterName}
                    totalCount={totalCount}
                    valuesToShow={valuesToShow}
                    displayUriRef={displayUriRef}
                    canBeDismissed={canBeDismissed}
                    appliedFilterValues={appliedFilterValues}
                />
            )}
        </SbSharedRefineMenuTypeaheadContainer>
    );
};

SbSharedRefineMenuRadioSelectSearchComponent.propTypes = {
    totalCount: PropTypes.number,
    values: PropTypes.array.isRequired,
    viewer: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbSharedRefineMenuRadioSelectSearch = createFragmentContainer(
    SbSharedRefineMenuRadioSelectSearchComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuRadioSelectSearch_viewer on Viewer {
                ...SbSharedRefineMenuTypeaheadContainer_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuRadioSelectSearch_searchBrowse on SearchBrowseQueryConnection {
                displayUriRef
                ...SbSharedRefineMenuTypeaheadContainer_searchBrowse
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
